import { useEffect, useState } from "react";
import Footer from "./Footer";
import LegalModal from "./LegalModal";
import { AUTH_URL } from "../lib/authUrl";

export default function AppView() {
  const [loaded, setLoaded] = useState(false);
  const [legalDoc, setLegalDoc] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
  }, []);

  return (
    <div data-testid="app-view" className="min-h-screen">
      <main className="relative z-[2]">
        <div className="relative bg-[#0B1120]">
          {!loaded && (
            <div
              data-testid="app-iframe-loading"
              className="absolute inset-0 z-10 grid place-items-center bg-[#0B1120]"
            >
              <div className="flex flex-col items-center gap-4">
                <svg viewBox="0 0 40 40" className="h-12 w-12 animate-pulse" aria-hidden="true">
                  <defs>
                    <linearGradient id="cdm-g-load" x1="0" y1="0" x2="1" y2="1">
                      <stop offset="0%" stopColor="#10B981" />
                      <stop offset="100%" stopColor="#14B8A6" />
                    </linearGradient>
                  </defs>
                  <rect x="1" y="1" width="38" height="38" rx="11" fill="url(#cdm-g-load)" />
                  <path d="M12 15.5h13.5M22 11.5l4 4-4 4" stroke="#04121B" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                  <path d="M28 25.5H14.5M18 21.5l-4 4 4 4" stroke="#04121B" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                </svg>
                <p className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500">
                  Loading CDM Pay account…
                </p>
              </div>
            </div>
          )}
          <iframe
            data-testid="app-iframe"
            src={AUTH_URL}
            title="CDM Pay Application"
            className="app-frame block w-full border-0 bg-[#0B1120]"
            loading="eager"
            allow="clipboard-write"
            referrerPolicy="strict-origin-when-cross-origin"
            onLoad={() => setLoaded(true)}
          />
        </div>
      </main>

      <Footer onLegal={setLegalDoc} />
      <LegalModal doc={legalDoc} onClose={() => setLegalDoc(null)} />
    </div>
  );
}
